import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconGutterVertical12 from './IconGutterVertical12';
import IconGutterVertical16 from './IconGutterVertical16';
import IconGutterVertical20 from './IconGutterVertical20';
import IconGutterVertical24 from './IconGutterVertical24';
import IconGutterVertical32 from './IconGutterVertical32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconGutterVertical = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconGutterVertical12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconGutterVertical16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconGutterVertical20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconGutterVertical24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconGutterVertical32 {...props} />}
        </span>
    );
};
IconGutterVertical.displayName = 'FondueIconGutterVertical';

export default memo(IconGutterVertical);
